module.exports = __webpack_public_path__ + "media/img/vca/sponsors/vrworld-812c939d7b2d117b03d58596f20d3ba3.png";